module.exports = __webpack_public_path__ + "img/logo.de50fb75.png";